export default __webpack_public_path__ + "static/media/avatar_mei_ling3.e8d8f833.mp3";